"use client";

import React, { useState, useRef, useEffect } from "react";
import { StyledDiv } from "./addWidgetToPlatform.styles";
import { IoMdClose } from "@react-icons/all-files/io/IoMdClose";
import { IPlatform, IPlugin } from "../../types";
import { CustomLink } from "../link/link.comp";

interface IAddWidgetToPlatformProps {
  platforms: IPlatform[];
  widget: IPlugin;
}

export const AddWidgetToPlatform = ({
  platforms,
  widget,
}: IAddWidgetToPlatformProps) => {
  const [open, setOpen] = useState(false);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [filter, setFilter] = useState({
    name: "",
  });

  const inputRef = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [containerRef]);

  const filteredPlatforms = platforms.filter((p) =>
    p.title.toLowerCase().includes(filter.name.toLowerCase())
  );

  return (
    <>
      <StyledDiv ref={containerRef}>
        <h2>How to Embed {widget.name} on Your Platform</h2>
        <p>
          Choose your platform to see detailed, step-by-step instructions for
          embedding {widget.name} seamlessly.
        </p>
        <div className="form-wrapper">
          <form
            className="search-components"
            onSubmit={(e) => e.preventDefault()}
          >
            <input
              ref={inputRef}
              title="Search Platforms"
              placeholder="Search for a platform..."
              value={filter.name}
              onFocus={() => setOpen(true)}
              onChange={(e) => {
                setFilter({ ...filter, name: e.target.value });
              }}
            />
            {filter.name && (
              <IoMdClose
                onClick={() => {
                  setFilter({ ...filter, name: "" });
                  setSelectedPlatform("");
                }}
                className="reset"
                fontSize={20}
              />
            )}
          </form>
          {selectedPlatform && (
            <CustomLink
              href={`/widgets/${
                widget.seoSlug || widget.slug
              }/${selectedPlatform}/how-to-add`}
            >
              View Guide
            </CustomLink>
          )}
        </div>

        <div
          className={`platform-results ${
            open && filteredPlatforms.length > 0 ? "show" : ""
          }`}
        >
          {filteredPlatforms.map((p) => (
            <div
              key={p.id}
              className={`platform ${
                selectedPlatform === p.slug ? "active" : ""
              }`}
              onClick={() => {
                setSelectedPlatform(p.slug || "");
                setFilter({ name: p.title });
                setOpen(false);
              }}
            >
              <img src={p.logo} alt={p.title} />
            </div>
          ))}
        </div>
      </StyledDiv>
    </>
  );
};
